import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {CommonService} from '../../services/common.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {ReportService} from '../../services/report.service';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-my-affirmations',
  templateUrl: './my-affirmations.component.html',
  styleUrls: ['./my-affirmations.component.scss']
})
export class MyAffirmationsComponent implements OnInit {
  // myAffirmations: ChildrenAffirmation[] = [];
  myAffirmations: any[] = [];
  @Input() user: any;
  isLoading: boolean;
  // columnsToDisplay = ['positionz', 'activity_description', 'childDisplayName', 'alt_description', 'enroll_date', 'cancel_date', 'actions'];
  columnsToDisplay = ['activity_description', 'childDisplayName', 'alt_description', 'enroll_date', 'actions'];
  constructor(public commonService: CommonService,
              public dialog: MatDialog,
              public router: Router,
              private localStorageService: LocalStorageService,
              private reportService: ReportService,
              public toastMessagesService: ToastMessagesService) {
    this.isLoading = false;
    // this.user = JSON.parse(this.localStorageService.get('user'));
  }

  async ngOnInit() {
    // await this.initMyAffirmations();
    await this.initializeAffirmations();
  }
  async initializeAffirmations() {
    let consentRecords = [];
    try {
      const request = await this.reportService.getCustomAffirmationsReport(null, null, true);
      consentRecords = this.formatRecords(request);
      console.log(request);
      this.myAffirmations = consentRecords;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  formatRecords(request: any) {
    const consentRecords = [];
    let position = 1;
    for (const consent of request) {
      for (const question of consent.questions) {
        for (const accepted of question.accepted) {
          const recordModel = {
            position,
            id: consent.id,
            reportId: accepted.reportId,
            activity_description: question.title,
            status: 1,
            childDisplayName: `${accepted.childInfo.firstName} ${accepted.childInfo.lastName}`,
            childId: accepted.childInfo.id,
            enroll_date: accepted.completed_at,
            unique_id: consent.unique_id
          };
          consentRecords.push(recordModel);
          position++;
        }

        for (const denied of question.denied) {
          const recordModel = {
            position,
            id: consent.id,
            reportId: denied.reportId,
            activity_description: question.title,
            status: 2,
            childDisplayName: `${denied.childInfo.firstName} ${denied.childInfo.lastName}`,
            childId: denied.childInfo.id,
            enroll_date: '-',
            unique_id: consent.unique_id
          };
          consentRecords.push(recordModel);
          position++;
        }

        for (const pending of question.pending) {
          const recordModel = {
            position,
            reportId: pending.reportId,
            id: consent.id,
            consent: question.title,
            status: -1,
            childDisplayName: `${pending.childInfo.firstName} ${pending.childInfo.lastName}`,
            childId: pending.childInfo.id,
            enroll_date: '-',
            unique_id: consent.unique_id
          };
          consentRecords.push(recordModel);
          position++;
        }
      }
    }

    return consentRecords;
  }

  async initMyAffirmations() {
    try {
      this.isLoading = true;
      const affirmationsRequest = await this.commonService.getList(`affirmations/children`);
      let position = 1;
      for (const affirmation of affirmationsRequest.object) {
        affirmation.childDisplayName = `${affirmation.child_first_name} ${affirmation.child_last_name}`;
        affirmation.position = position;
        position++;
      }
      this.myAffirmations = affirmationsRequest.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  async cancel(affirmation) {
    console.log(affirmation);
    const confirm = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να ακυρώσετε την
         δραστηριότητα για τον/την ${affirmation.child_first_name} ${affirmation.child_last_name}`,
        title: `Ακύρωση δραστηριότητας`,
        icon: 'cancel',
        iconColor: 'red',
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.updateItem(`affirmations/cancelEnrollment?id=${affirmation.id}`, {});
          this.toastMessagesService.toastMessages('Η δραστηριότητα ακυρώθηκε με επιτυχία');
          await this.initMyAffirmations();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  async renew(affirmation) {
    const confirm = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να ανανεώσετε την
         δραστηριότητα για τον/την ${affirmation.child_first_name} ${affirmation.child_last_name}`,
        title: `Ανανέωση δραστηριότητας`,
        icon: 'autorenew',
        iconColor: 'red',
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.updateItem(`affirmations/renewEnrollment?id=${affirmation.id}`, {});
          this.toastMessagesService.toastMessages('Η δραστηριότητα ακυρώθηκε με επιτυχία');
          await this.initMyAffirmations();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      } });
  }

  async showCustomForm(form) {
    const inputConfig = {
      edit: false,
      childId: form.childId,
      mode: true,
      parentId: this.user.id,
      unique_id: form.unique_id,
      id: form.reportId,
      update: true
    };
    await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
  }
}
